import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = ["input", "label", "errorMessage"]

    connect() {
        this.initializeFloatingLabel()
        this.applyErrorClasses()
        this.observeErrorAttribute()
    }

    initializeFloatingLabel() {
        this.updateLabelPosition()
        this.inputTarget.addEventListener('focus', () => this.handleFocus())
        this.inputTarget.addEventListener('blur', () => this.handleBlur())
        this.inputTarget.addEventListener('input', () => this.updateLabelPosition())
    }

    handleFocus() {
        this.labelTarget.classList.add('floating-label-active')
    }

    handleBlur() {
        this.updateLabelPosition()
    }

    updateLabelPosition() {
        if (this.inputTarget.value.trim() !== '' || this.inputTarget === document.activeElement) {
            this.labelTarget.classList.add('floating-label-active')
        } else {
            this.labelTarget.classList.remove('floating-label-active')
        }
    }

    applyErrorClasses() {
        const hasError = this.element.dataset.floatingLabelError !== ""
        if (hasError) {
            this.inputTarget.classList.add('floating-input-error')
            this.labelTarget.classList.add('floating-label-error')
            this.errorMessageTarget.textContent = this.element.dataset.floatingLabelError
        } else {
            this.clearError()
        }
    }

    clearError() {
        this.inputTarget.classList.remove('floating-input-error')
        this.labelTarget.classList.remove('floating-label-error')
        this.errorMessageTarget.textContent = ''
    }

    observeErrorAttribute() {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "data-floating-label-error"
                ) {
                    this.applyErrorClasses()
                }
            })
        })
        observer.observe(this.element, { attributes: true })
        this.errorObserver = observer
    }

    disconnect() {
        if (this.errorObserver) {
            this.errorObserver.disconnect()
        }
    }
}
